<template>
	<div>
		<el-table :data="Loglist" border v-loading="listloading" style="width: 100%" max-height="680">
		    <el-table-column prop="time" label="时间" width="170" :formatter="dateFormat"></el-table-column>
		    <el-table-column prop="content" label="内容"></el-table-column>
  		</el-table>
  		
  		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
//	import {GetLogs} from "../api/api"
	
	export default {
		data(){
			return{
				token:"",
				Loglist:[],
				listloading:false,
				total:100,
				Curpage:1,
				Pagesize:10,
				token:"iCfKzVPZHldaQtz5Dfd/oRPcrYQ42ak8bIko9+w2olV6gdNdDsDQrFItx88HfCVm1ibMmdhqKQbzm5yz5qvqMwQb4+6NJD+U7DvxOZXNVwhuGZpqgk65lIRJC/IXs2Tph4Wk3T+3FxNC+KMQ9QfZLVEdngEYQwznLgNvFfCXc9/A3PvUu4h3UGEyWQEolC6d8a/pcGTFKfePnHN1LBsLEWJWiJqaTz/Xe+zCxtL1Zrmzw5U+t7bAzFHbS2GS06U9TKhBQ02MZ6qrYBr5IyF8Ghkv2qDvU4yAUwBrtqRO3qkyCv3H0me/RJabCXoKrsiz5XUIbuofeWV3v3Cklh1XgZenf/bM3Kk7xhe6dFO3qcGZ4V/X45wQR/PXMOuVHeqRq9KN5cnSgw8nVuvrvS/C3Rno4SlZsuGarlT5y3NLdcm5KbnWPNMedJaW4u0C8sYfLPjGl7N/Y7qVGG6VJon+1pShrjMAiPI/cpDoKX7AdHtrZ8SfBRZlW9sfRn+6XFkcUZuiDSdm8yxwV6Hx3jltfTDKU01Nh8/zfkPnCDZ2zOViDsRLZ4CdBQ3SjnSuCNiDg9JCR/iHlHx1Tstsx/UXVNjR32/eAjbDxS19PWut2ee4SL1qbL0FOdZIIR8MXShoSTPPgYC/a3hZyp3OL+9nLdpA9PXd3mznIo8hAZ8vpiqwAlM"
			}
		},
		methods:{
			handleCurrentChange(val){
				this.Curpage = val
				this.Getlist()
			},
			Getlist(){
				let param = {
					curPage:this.Curpage,
					pageSize:this.Pagesize,
					token:this.token
//					page:this.Curpage,
//					fields:"id,info,mac,time",
//					q:this.Findform
				}
				this.listloading = true
				GetLogs(param).then(res => {
					console.log(res)
					this.Loglist = res.data.data
					this.total = res.data.totalRows
					this.loading = false
//					this.Loglist = res.data.items
//					this.Pagesize = res.data.meta.perPage
//					this.total = res.data.meta.totalCount
					this.listloading = false
				}).catch(err => {
					console.log(err)
					this.$message.error('对不起，请求失败。')
					this.listloading = false
				})
			},

		},
		created(){
//			this.token = sessionStorage.getItem("BBRtoken");
//			this.Getlist()
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Log.vue?7a6d253c